import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { AppProviders } from "@client/app/providers";
import { createRouter } from "@client/app/router";
import { LANGUAGE_SWITCH_ENABLED } from "@client/i18n";
import "./index.css";

const container = document.getElementById("root");
if (!container) throw new Error("No #root element — check client/index.html");

// 2026-09-28: the app is Swedish only — force it regardless of the stored or
// profile language (`LANGUAGE_SWITCH_ENABLED`, `client/src/i18n/index.tsx`).
createRoot(container).render(
  <StrictMode>
    <AppProviders {...(LANGUAGE_SWITCH_ENABLED ? {} : { lang: "sv" })}>
      <RouterProvider router={createRouter()} />
    </AppProviders>
  </StrictMode>,
);
